import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhoneAlt,
  FaInstagram,
  FaFacebookF,
  FaYoutube,
} from "react-icons/fa";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();
  const whatsappLink = "https://wa.me/5452523725"; // Replace with your WhatsApp link
  return (
    <footer className="bg-[#19244a] w-full relative">
      <div className="px-3 sm:px-6 pt-10 sm:pt-12 pb-4 sm:pb-6 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 items-start">
          {/* Sol Blok */}
          <div className="flex flex-col gap-6">
            <ul className="space-y-4 text-[#e8d1b9]">
              <li className="flex items-center gap-3 sm:gap-4">
                <span className="bg-[#bda088] text-[#232c3b] rounded-full p-2.5 sm:p-3 flex items-center justify-center shrink-0">
                  <FaMapMarkerAlt className="text-[16px] sm:text-[18px]" />
                </span>
                <address className="not-italic leading-relaxed text-sm sm:text-base">
                  {t("footer.address")}
                </address>
              </li>

              <li className="flex items-center gap-3 sm:gap-4">
                <span className="bg-[#bda088] text-[#232c3b] rounded-full p-2.5 sm:p-3 flex items-center justify-center shrink-0">
                  <FaEnvelope className="text-[16px] sm:text-[18px]" />
                </span>
                <a
                  href={`mailto:${t("footer.email")}`}
                  className="hover:underline text-[#e8d1b9] text-sm sm:text-base break-all"
                >
                  {t("footer.email")}
                </a>
              </li>

              <li className="flex items-center gap-3 sm:gap-4">
                <span className="bg-[#bda088] text-[#232c3b] rounded-full p-2.5 sm:p-3 flex items-center justify-center shrink-0">
                  <FaPhoneAlt className="text-[16px] sm:text-[18px]" />
                </span>
                <a
                  href={`tel:${t("footer.phone")}`}
                  className="hover:underline text-[#e8d1b9] text-sm sm:text-base"
                >
                  {t("footer.phone")}
                </a>
              </li>
            </ul>
          </div>

          {/* Orta Blok */}
          <div className="flex flex-col items-center md:items-center text-center gap-3 sm:gap-4">
            <h3 className="text-[#e8d1b9] text-lg sm:text-xl font-bold">
              {t("footer.socialTitle")}
            </h3>
            <div className="text-[#e8d1b9] font-bold text-base sm:text-lg">
              {t("footer.socialHandle")}
            </div>
            <div className="flex flex-wrap justify-center gap-4 sm:gap-6 mt-1 sm:mt-2">
              <a
                href="https://facebook.com/drserkanaygin"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="bg-[#bda088] hover:bg-[#e8d1b9] text-[#232c3b] rounded-full p-3 sm:p-3.5 transition inline-flex"
              >
                <FaFacebookF className="text-[18px] sm:text-[20px]" />
              </a>
              <a
                href="https://instagram.com/drserkanaygin"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="bg-[#bda088] hover:bg-[#e8d1b9] text-[#232c3b] rounded-full p-3 sm:p-3.5 transition inline-flex"
              >
                <FaInstagram className="text-[18px] sm:text-[20px]" />
              </a>
              <a
                href="https://youtube.com/@drserkanaygin"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
                className="bg-[#bda088] hover:bg-[#e8d1b9] text-[#232c3b] rounded-full p-3 sm:p-3.5 transition inline-flex"
              >
                <FaYoutube className="text-[18px] sm:text-[20px]" />
              </a>
            </div>
          </div>

          {/* Sağ Blok */}
          <div className="md:justify-end flex">
            <div className="rounded-2xl bg-gradient-to-r from-[#bda088] to-[#a89281] shadow-lg w-full md:w-auto px-5 sm:px-6 py-5 sm:py-6 max-w-[380px] mx-auto md:mx-0">
              <h4 className="text-[#181b23] font-bold text-base sm:text-lg mb-2.5 sm:mb-3 text-center">
                {t("footer.consultTitle")}
              </h4>
              <p className="text-[#232c3b] text-sm sm:text-base text-center mb-4 sm:mb-5 leading-relaxed">
                {t("footer.consultDesc")}
              </p>
              <a
                href={whatsappLink}
                className="block text-center bg-[#19244a] hover:bg-[#232c3b] text-white text-xs sm:text-sm font-bold px-4 sm:px-5 py-2 sm:py-2.5 rounded-lg transition"
              >
                {t("footer.consultBtn")}
              </a>
            </div>
          </div>
        </div>

        {/* Alt Satır */}
        <div className="mt-6 sm:mt-8 border-t border-white/10 pt-4 sm:pt-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-white/60 text-xs sm:text-sm text-center md:text-left">
            © {new Date().getFullYear()} {t("footer.rights")}
          </p>
        </div>
      </div>
    </footer>
  );
}
